var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-subheader"},[_c('div',{staticClass:"filter-subheader__text"},[_vm._v(" Jugadores que participaron ")]),_c('div',{staticClass:"filter-subheader__icon"},[_c('div')])])
}]

export { render, staticRenderFns }